import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import shortid from "shortid";

import WP, { fetchWP } from "WP";
import styled from "styled-components";

class LangSwitcher extends Component {
  _switchLanguage(e, lang) {
    e.preventDefault();

    if (lang === WP.lang) return;

    let redirectPath = lang === "en" ? "/en" : "/";

    // set the pll_language cookie to new value
    let now = new Date();
    now.setFullYear(now.getFullYear() + 1);
    document.cookie = `pll_language=${lang}; expires=${now.toGMTString()}; path=/;`;

    const currentView = this.props.currentView;
    // if current view data are saved in store && their translation info is available
    if (
      currentView &&
      currentView.translation_paths &&
      currentView.translation_paths[lang]
    ) {
      if (
        currentView.translation_paths[lang] &&
        currentView.translation_paths.no !== currentView.translation_paths.en
      ) {
        // only if translation path is available (page has translation) - if not redirection to home from above will be used
        currentView.translation_paths[lang] = currentView.translation_paths[
          lang
        ].replace("/en/", "/");
        redirectPath = redirectPath + currentView.translation_paths[lang];
        // Match and remove https://localhost or http://localhost from path if present
        // this was done to prevent localhost from being added to the path as it was causing a bug on prod
        redirectPath = redirectPath.replace(/https?:\/\/localhost/, "");
        redirectPath = redirectPath.replace("//", "/");
      }

      //remove hash
      redirectPath = redirectPath.split("#")[0];
    }

    // add a unique 'id' to url (required on some browsers when changing lang. on home page)
    if (redirectPath === "/" || redirectPath === "/en/") {
      redirectPath = redirectPath + "?c=" + shortid.generate();
    }

    if (process.env.NODE_ENV === "development") {
      // fetch WP and redirect to corresponding translation OR home page
      fetchWP(lang, redirectPath);
    } else {
      // redirect to corresponding translation OR home page
      window.location.replace(redirectPath);
    }
  }

  render() {
    const { fixed } = this.props;
    return (
      <Wrapper
        color={this.props.color}
        fixed={fixed}
        isDark={this.props.isDark}
      >
        <a
          onClick={(e) => this._switchLanguage(e, "no")}
          className={WP.lang === "no" ? "active" : ""}
        >
          NO
        </a>
        <span>/</span>
        <a
          onClick={(e) => this._switchLanguage(e, "en")}
          className={WP.lang === "en" ? "active" : ""}
        >
          EN
        </a>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentView: state.currentView,
  };
};

export default connect(mapStateToProps, null)(withRouter(LangSwitcher));

const Wrapper = styled.div`
  color: ${(props) =>
    props.fixed || props.isDark
      ? props.theme.colors.negative
      : props.color
      ? props.color
      : props.theme.colors.text};
  z-index: 5;

  a {
    cursor: pointer;
    position: relative;
    transition: opacity 0.2s ease;
    color: ${(props) =>
      props.fixed || props.isDark
        ? props.theme.colors.negative
        : props.color
        ? props.color
        : props.theme.colors.text};

    &:hover {
      opacity: 0.8;
    }

    &.active,
    &.active:hover {
      cursor: default;

      &::after {
        position: absolute;
        content: "";
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${(props) =>
          props.fixed || props.isDark
            ? props.theme.colors.negative
            : props.color
            ? props.color
            : props.theme.colors.text};
      }
    }
  }
`;
